module.exports = __webpack_public_path__ + "static/media/logout.9756ef17.png";